// CMS uses language id instead of string

import { CMSLANGUAGEIDS } from "app/utils/const";

export class CmsHelper {
  /**
   * Gets a language ID for CMS content
   * Dev envs have different IDs than prod/preprod
   * @param language
   * @returns number
   */
  static getLanguageId(language: string): number {
    const devEnvs = [
      "selena.3et.com",
      "sandra.3et.com",
      "sonia.3et.com",
      "bpmdev.3et.com",
      "alpha.3et.com",
      "localhost",
    ];

    const domain = window.location.hostname;
    let environment = devEnvs.includes(domain) ? "development" : "production";

    if (language in CMSLANGUAGEIDS[environment]) {
      return CMSLANGUAGEIDS[environment][language];
    } else {
      console.log(
        `Language '${language}' not found in environment '${environment}'. Defaulting to English (id=1).`
      );
      return 1;
    }
  }
}
